// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-container {\n    font-family: inherit;\n    font-size: inherit;\n}\n\n.ql-editor {\n    line-height: inherit;\n    padding: 0;\n    text-align: inherit;\n    white-space: inherit;\n    word-break: inherit;\n}", ""]);
// Exports
module.exports = exports;
